export const formatCurrency = (
  value: number,
  options?: Intl.NumberFormatOptions,
) =>
  new Intl.NumberFormat(`en-US`, {
    currency: `USD`,
    style: 'currency',
    ...options,
  }).format(value);

export const floorToTwoDecimals = (value: number) => _.floor(value, 2);

export const convertToNumber = (value: any) =>
  _.isNil(value) ? undefined : Number(value);
